import React from 'react';

import { CreditInformation as CreditInformationPackage } from '@eika-kortbetjening/card-balance-transaction-list';

import { AccountService } from '@/domain/account';
import piwik from '@/piwik/piwik';

import { CreditCardAccount } from '@generated-types';
import useText from '@hooks/use-text';

type CreditInformationProps = {
    account: CreditCardAccount;
};

export const CreditInformation = ({ account }: CreditInformationProps) => {
    const { transactionsCreditInfoUsed, transactionsCreditInfoAvailable } = useText();
    const balance = AccountService.getBalance(account);
    const title = balance.saldo > 0 ? transactionsCreditInfoAvailable : transactionsCreditInfoUsed;

    return (
        <div className="credit-information-container">
            <CreditInformationPackage balance={balance} piwik={piwik} title={title} />
        </div>
    );
};
